const CommissionPoints = () => import('Views/config/commission-points');
const Coupon = () => import('Views/config/coupon');

export default[
  { path: '/commission-points', component: CommissionPoints },
  { path: '/coupon', component: Coupon },
];



// WEBPACK FOOTER //
// ./src/router/config.js